import BlankMyPrepaidCard from '@components/blank/BlankMyPrepaidCard';
import Column from '@components/Column';
import Loading from '@components/Loading';

import useUserPrepaidCards from '../../hooks/useUserPrepaidCards';
import PrepaidCardItem from '../PrepaidCardItem';
import styles from './styles.module.scss';

function PrepaidCardList() {
    const { prepaidCards, isLoading, isBlank } = useUserPrepaidCards();
    return (
        <Column className={styles.container}
            as='section'
            fullWidth
            align='center'
            spacing={18}>
            {isLoading && (
                <Loading size='small' />
            )}
            {isBlank && (
                <BlankMyPrepaidCard/>
            )}
            {prepaidCards?.map((prepaidCard) => (
                <PrepaidCardItem prepaidCard={prepaidCard}
                    key={prepaidCard.id} />
            ))}
        </Column>
    );
}

export default PrepaidCardList;
